import {makeBFFApiUrl} from 'main/factories/http/api-bff-url-factory';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetExamsAuthorization} from 'data/usecases/private/booking-flow/exams/remote-get-exams-authorizations';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import type {GetExamsAuthorization} from 'domain/usecases/private/booking-flow/exams/get-exams-authorization';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';

export const makeGetExamsAuthorization = (): GetExamsAuthorization => {
	const isExamsAuthorizationV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_AUTHORIZATION_V3,
	);

	const endpoint = isExamsAuthorizationV3Enabled
		? BookingFlowEndPoints.examsAuthorizationV3
		: BookingFlowEndPoints.examsAuthorization;

	return new RemoteGetExamsAuthorization(
		makeBFFApiUrl(endpoint),
		makeAuthorizeHttpClientDecorator(),
	);
};
